export default "__VITE_ASSET__DzhIIPeh__"